const targetSelector = 'product-card, quick-add-component, .section-resource-list, product-recommendations';
const quickAddClickSelector = 'quick-add-component [on\\:click^="quick-add-component/"]';
const intentEvents = ['pointerover', 'focusin', 'touchstart'];

let loadPromise;

function loadProductCardScripts() {
  if (loadPromise) return loadPromise;

  document.documentElement.dataset.spProductCardScripts = 'loading';

  loadPromise = Promise.allSettled([import('@theme/product-card'), import('@theme/quick-add')])
    .then((results) => {
      const failed = results.find((result) => result.status === 'rejected');

      if (failed) {
        throw failed.reason;
      }

      return Promise.all([
        customElements.whenDefined('product-card'),
        customElements.whenDefined('quick-add-component'),
      ]);
    })
    .then(() => {
      document.documentElement.dataset.spProductCardScripts = 'loaded';
    })
    .catch((error) => {
      document.documentElement.dataset.spProductCardScripts = 'error';
      loadPromise = undefined;
      throw error;
    });

  return loadPromise;
}

function warnLoadFailure(error) {
  console.warn('[Starryve] Product card interactions failed to load.', error);
}

function scriptsAreReady() {
  return customElements.get('product-card') && customElements.get('quick-add-component');
}

function findQuickAddClickTrigger(event) {
  const target = event.target;

  return target instanceof Element ? target.closest(quickAddClickSelector) : null;
}

function replayClick(trigger) {
  window.requestAnimationFrame(() => {
    trigger.dispatchEvent(new MouseEvent('click', { bubbles: true, cancelable: true, view: window }));
  });
}

function handleIntent(event) {
  if (!(event.target instanceof Element)) return;
  if (!event.target.closest(targetSelector)) return;

  for (const eventName of intentEvents) {
    document.removeEventListener(eventName, handleIntent, { capture: true });
  }

  loadProductCardScripts().catch(warnLoadFailure);
}

function observeDeferredProductCards() {
  const targets = document.querySelectorAll(targetSelector);
  if (!targets.length) return;

  for (const eventName of intentEvents) {
    document.addEventListener(eventName, handleIntent, { capture: true, passive: true });
  }

  if (!('IntersectionObserver' in window)) {
    loadProductCardScripts().catch(warnLoadFailure);
    return;
  }

  const observer = new IntersectionObserver(
    (entries) => {
      if (!entries.some((entry) => entry.isIntersecting)) return;

      observer.disconnect();
      loadProductCardScripts().catch(warnLoadFailure);
    },
    { rootMargin: '900px 0px' }
  );

  targets.forEach((target) => observer.observe(target));
}

document.addEventListener(
  'click',
  (event) => {
    const trigger = findQuickAddClickTrigger(event);

    if (!trigger || scriptsAreReady()) return;

    event.preventDefault();
    event.stopImmediatePropagation();

    loadProductCardScripts()
      .then(() => replayClick(trigger))
      .catch(warnLoadFailure);
  },
  { capture: true }
);

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', observeDeferredProductCards, { once: true });
} else {
  observeDeferredProductCards();
}
